export default {"src":"/_next/static/media/gezondheid.ebc82cbb.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};